import React, { useEffect, useState } from "react";
import { getNewBusinessReport } from "../../../actions/report";
import { Divider, AutoComplete, Row, Col, Select, Skeleton, TreeSelect, Button, InputNumber, Checkbox, DatePicker, Space, Card } from "antd";
import moment from "moment";

const { Option } = Select;

const NewBusinessReport = () => {
  const [List, setList] = useState([]);
  const [reload, setreload] = useState(false);
  const [loading, setloading] = useState(true);
  const [period, setPeriod] = useState("daily"); // daily, weekly, monthly
  const [startDate, setStartDate] = useState(moment());
  const [endDate, setEndDate] = useState(moment());
  var formatter = new Intl.NumberFormat("en-IN");

  useEffect(() => {
    fetchReport();
  }, [reload, period, startDate, endDate]);

  const fetchReport = () => {
    setloading(true);
    const start = startDate.format("YYYY-MM-DD");
    const end = endDate.format("YYYY-MM-DD");
    
    getNewBusinessReport(start, end)
      .then((res) => {
        setList(res.data);
      })
      .catch((error) => console.log(error))
      .finally(() => setloading(false));
  };


  const renderDetails = (type) => {
    return List.map((item) => {
      if (item.type === type)
        return (
          <tr>
            <td style={{fontWeight:item.weight}}>{item.name}</td>
            <td style={{textAlign:"right",fontWeight:item.weight}}>{formatter.format(item.amount)}</td>
          </tr>
        )
    })
  }

  const renderdata = () => {
    if (loading) {
      return <Skeleton active />;
    } else {
      return <>
      <Row>
        <Col span={10}>
          <Row>
            <Col span={24} style={{padding:"10px", borderBottom:"1px solid #d6d6d6ff"}}>
              <h3>Stock</h3>
              <table style={{width:"100%", }}>
              {renderDetails("Stock")}
              </table>
            </Col>
            <Col span={24} style={{padding:"10px", borderBottom:"1px solid #d6d6d6ff"}}>
              <h3>Profit / Loss</h3>
              <table style={{width:"100%"}}>
              {renderDetails("profitnloss")}
              </table>
            </Col>
          </Row>
        </Col>
        <Col span={10} offset={4}>
        <Row>
          <Col span={24} style={{padding:"10px", borderBottom:"1px solid #d6d6d6ff"}}>
            <h3>Deposite</h3>
            <table style={{width:"100%"}}>
            {renderDetails("Payment Methods")}
              </table>
          </Col>
          <Col span={24} style={{padding:"10px", borderBottom:"1px solid #d6d6d6ff"}}>
            <h3>Due</h3>
            <table style={{width:"100%"}}>
            {renderDetails("Due")}
            </table>
          </Col>
        </Row>
        </Col>
      </Row>
      
        
      </>
    }
  };

  const handlePeriodChange = (value) => {
    setPeriod(value);
    const today = moment();
    
    switch(value) {
      case "daily":
        setStartDate(moment(today));
        setEndDate(moment(today));
        break;
      case "monthly":
        setStartDate(moment(today).startOf('month'));
        setEndDate(moment(today).endOf('month'));
        break;
      case "half-yearly":
        // Determine which half of the year we're in
        const currentMonth = today.month(); // 0-11
        if (currentMonth < 6) {
          // First half (Jan-Jun)
          setStartDate(moment(today).startOf('year'));
          setEndDate(moment(today).month(5).endOf('month'));
        } else {
          // Second half (Jul-Dec)
          setStartDate(moment(today).month(6).startOf('month'));
          setEndDate(moment(today).endOf('year'));
        }
        break;
      case "yearly":
        setStartDate(moment(today).startOf('year'));
        setEndDate(moment(today).endOf('year'));
        break;
      default:
        break;
    }
  };

  const handleDateChange = (date) => {
    if (!date) return;
    
    switch(period) {
      case "daily":
        setStartDate(moment(date));
        setEndDate(moment(date));
        break;
      case "monthly":
        setStartDate(moment(date).startOf('month'));
        setEndDate(moment(date).endOf('month'));
        break;
      case "half-yearly":
        // Determine which half based on selected month
        const selectedMonth = date.month(); // 0-11
        if (selectedMonth < 6) {
          // First half (Jan-Jun)
          setStartDate(moment(date).startOf('year'));
          setEndDate(moment(date).month(5).endOf('month'));
        } else {
          // Second half (Jul-Dec)
          setStartDate(moment(date).month(6).startOf('month'));
          setEndDate(moment(date).endOf('year'));
        }
        break;
      case "yearly":
        setStartDate(moment(date).startOf('year'));
        setEndDate(moment(date).endOf('year'));
        break;
      default:
        break;
    }
  };

  return (
    <>
      <Card style={{ marginBottom: 16 }}>
        <Space size="large">
          <div>
            <label style={{ marginRight: 8, fontWeight: 500 }}>Period:</label>
            <Select
              value={period}
              onChange={handlePeriodChange}
              style={{ width: 140 }}
            >
              <Option value="daily">Daily</Option>
              <Option value="monthly">Monthly</Option>
              <Option value="half-yearly">Half-Yearly</Option>
              <Option value="yearly">Yearly</Option>
            </Select>
          </div>
          <div>
            <label style={{ marginRight: 8, fontWeight: 500 }}>
              {period === "daily" && "Select Date:"}
              {period === "monthly" && "Select Month:"}
              {period === "half-yearly" && "Select Half:"}
              {period === "yearly" && "Select Year:"}
            </label>
            {period === "daily" ? (
              <DatePicker
                value={startDate}
                onChange={(date) => {
                  if (date) {
                    setStartDate(date);
                    setEndDate(date);
                  }
                }}
                format="YYYY-MM-DD"
              />
            ) : (
              <DatePicker
                key={period}
                value={startDate}
                onChange={handleDateChange}
                picker={
                  period === "monthly" ? "month" : 
                  period === "yearly" ? "year" :
                  "month" // half-yearly uses month picker
                }
                format={
                  period === "monthly" ? "YYYY-MM" :
                  period === "yearly" ? "YYYY" :
                  "YYYY-MM" // half-yearly shows month
                }
              />
            )}
          </div>
          
        </Space>
      </Card>
      
      <div style={{ color: '#666', fontSize: '14px', padding:"10px" }}>
        Range: {startDate.format("YYYY-MM-DD")} to {endDate.format("YYYY-MM-DD")}
      </div>
      {renderdata()}
     
    </>
  );
};

export default NewBusinessReport;